import { inject, Injectable, Injector } from '@angular/core';
import { StoreSelectionService } from '../services/store-selection.service';

@Injectable({
  providedIn: 'root',
})
export class StoreSelectionFacade {
  private readonly injector: Injector = inject(Injector);
  private storeSelectionService: StoreSelectionService | undefined;

  public get getStoreSelectionService(): StoreSelectionService {
    if (!this.storeSelectionService) {
      this.storeSelectionService = this.injector.get(StoreSelectionService);
    }
    return this.storeSelectionService;
  }

  public isOnStoreSelectionPage(): boolean {
    return this.getStoreSelectionService.isOnStoreSelectionPage();
  }
}
